// removed by extract-text-webpack-plugin
module.exports = {"ModalScrollWrapper":"ModalScroll-module__ModalScrollWrapper__2pXIU","ModalScrollWrapperFixed":"ModalScroll-module__ModalScrollWrapperFixed__wiUTI ModalScroll-module__ModalScrollWrapper__2pXIU","ModalScroll":"ModalScroll-module__ModalScroll__3-jHC","Navbar":"ModalScroll-module__Navbar__nTCaR","Children":"ModalScroll-module__Children__2TPxe","Bottom":"ModalScroll-module__Bottom__3vdOM","ModalScrollCollapsible":"ModalScroll-module__ModalScrollCollapsible__18c1g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ModalScroll/ModalScroll.module.css
// module id = 1723
// module chunks = 31